import React, { useState, useEffect } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";

function ForgotForm(props) {
  const [field, setField] = useState({ email: "" });
  const [login, setLogin] = useState(false);
  const [alert, setAlert] = useState({ state: false, data: null });
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("user") || sessionStorage.getItem("user")) {
      setLogin(true);
    }
  }, []);

  const validateField = () => true;

  const valueChanged = (event) => {
    const element = event.target;
    if (validateField(element)) {
      setField((prev) => ({
        ...prev,
        [element.id]: element.id === "store" ? element.checked : element.value,
      }));
    }
  };

  const validate = (event) => {
    event.preventDefault();

    setAlert({
      state: false,
      data: null,
    });

    setTimeout(() => {
      setAlert({
        state: true,
        data: {
          status: "#d62424",
          message: "Checking...",
        },
      });
    }, 500);

    setTimeout(() => {
      setAlert({
        state: true,
        data: {
          status: "#d62424",
          message: "Incorrect Email Address.",
        },
      });
    }, 1500);
  };

  if (login) {
    return <Navigate to="/app" />;
  }

  return (
    <div>
      <form onSubmit={validate}>
        <div className={["form-group"]}>
          <FontAwesomeIcon
            className={["icon"].join(" ")}
            icon={["fas", "at"]}
          />
          <input
            type={"text"}
            className={["form-control"]}
            id={"email"}
            value={field.email}
            placeholder={"email address"}
            onChange={valueChanged}
          />
        </div>

        <div
          className={["form-group", "statusContainer"].join(" ")}
          style={alert.data ? { color: alert.data.status } : {}}
        >
          {alert.state ? alert.data.message : <div />}
        </div>

        <button
          type={"submit"}
          className={["btn", "btn-primary"].join(" ")}
          disabled={!field.email}
        >
          Forgot Password
        </button>
      </form>

      <Link
        className={["formLink"].join(" ")}
        to={
          location.state && location.state.prevUrl
            ? location.state.prevUrl
            : "/login"
        }
      >
        Go Back
      </Link>
    </div>
  );
}

export default ForgotForm;
